import { Routes } from '../../utils/app-constants';

/**
 * A page that used to be at another address
 */
export interface ILegacyRoute {
    /** Where the page used to be */
    from: string;
    /** Where it is now */
    to: string;
}

/**
 * Every page is now at /{section}/{page}.  These are the addresses the pages had before, so a bookmark or a link in an email
 * still lands on the page: the visitor is sent to the page's address now, keeping whatever came after the old address
 * (an id, a date) and the query string.
 */
export const legacyRoutes: ILegacyRoute[] = [
    // Ordering and approvals
    { from: '/ordering/query',                to: Routes.ORDERING_ORDERS },
    { from: '/support/sync',                  to: Routes.ORDERING_SYNC },
    { from: '/ordering/credit-hold',          to: Routes.APPROVALS_CREDIT_HOLD },
    { from: '/ordering/review',               to: Routes.APPROVALS_ENGINEERING },
    { from: '/ordering/windload',             to: Routes.APPROVALS_WINDLOAD },
    { from: '/ordering/customer-service',     to: Routes.APPROVALS_CUSTOMER_SERVICE },
    { from: '/transportation/addresses',      to: Routes.APPROVALS_ADDRESSES },

    // Routing
    { from: '/transportation/planning',       to: Routes.ROUTING_ROUTING },

    // Shipping
    { from: '/transportation/shipments/pickups',      to: Routes.SHIPPING_PICKUPS },
    { from: '/transportation/shipments/trucks',       to: Routes.SHIPPING_TRUCKS },
    { from: '/transportation/shipments/containers',   to: Routes.SHIPPING_CONTAINERS },
    { from: '/transportation/fedex',          to: Routes.SHIPPING_FEDEX },
    // Billing only was the Fedex page before it had a page of its own
    { from: '/ordering/billing-only',         to: Routes.SHIPPING_FEDEX },
    { from: '/transportation/fleet',          to: Routes.SHIPPING_FLEET },

    // Invoicing
    { from: '/invoicing/credit-entry',        to: Routes.INVOICING_CREDITS },

    // Communications
    { from: '/transportation/communications', to: Routes.COMMUNICATIONS_SHIPMENTS },

    // Production
    { from: '/production/metrics',            to: Routes.PRODUCTION_PLANNING },

    // Reports
    { from: '/reporting',                     to: Routes.REPORTS_REPORTS }
];

/**
 * Pickups, trucks and containers used to be tabs on one shipments page, so there is no one page to send it to
 */
export const LEGACY_SHIPMENTS = '/transportation/shipments';
